// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, request } from "@insite/client-framework/Services/ApiService";
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { CatalogPageModel, ProductDto, ProductModel } from "@insite/client-framework/Types/ApiModels";

export interface BatchGetProductsApiParameter extends ApiParameter {
    extendedNames: string[];
}

export interface OwnProductDto extends ProductDto {
    index: number;
    key: string;
    product: ProductDto;
}

const productsUrl = "/api/mcmc/product";

const ootbProductsUrl = "/api/v2/products";
const catalogPagesUrl = "/api/v1/catalogpages";

export function batchGetProducts(parameter: BatchGetProductsApiParameter) {
    return request<(OwnProductDto | null)[]>(
        `${productsUrl}/batchget`,
        "POST",
        { "Content-Type": "application/json" },
        JSON.stringify({ extendedNames: parameter.extendedNames }),
    );
}

export async function getProductByPath(parameter: GetProductByPathApiV2Parameter) {
    const result = await get<CatalogPageModel>(`${catalogPagesUrl}`, { path: parameter.path } as ApiParameter);
    const productModel = await get<ProductModel>(`${ootbProductsUrl}/${result.productId}`, {
        expand: parameter.expand,
        additionalExpands: parameter.additionalExpands,
        includeAttributes: parameter.includeAttributes,
        addToRecentlyViewed: parameter.addToRecentlyViewed,
        categoryId: result.category?.id,
        ...((parameter as any).nocache === true ? { timestamp: new Date().getTime() } : {}),
    } as ApiParameter);

    return productModel;
}